import React, { createContext, useState, useEffect, useContext } from 'react';
import { useCoreStateContext } from 'spark-core-dx/contexts';

export const LandingDomainContext = createContext();

export function LandingDomainContextProvider({ children }) {

    const coreState = useCoreStateContext();
    //const coreAuthMgr = useGenericManager(ItemServiceFactory.ItemServiceEnum.);

    //const currentRoute = useCoreRoute();
    //const [loadingState, setLoadingState] = useState(true)
    //const location = useLocation();
    
    useEffect(() => {
        return () => {
            coreState.clear()
        }
    }, [])

    return (
        <LandingDomainContext.Provider value={'Test'}>
            {children}
        </LandingDomainContext.Provider>

    );
}
export const useLandingDomainContext = () => useContext(LandingDomainContext);